export enum ClientBills {
  Socar = 'Socar',
  BVS = 'BVS'
}
